var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleProducts2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 677,
    viewBox: "0 0 523 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_7446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 523,
    height: 677
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 523,
    height: 677,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_7446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.572 411.876C462.436 434.188 454.682 453.641 442.261 455.339C429.833 457.033 417.439 440.324 414.579 418.023C411.715 395.711 419.469 376.257 431.89 374.56C444.318 372.866 456.712 389.575 459.572 411.876Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.27 544.969C407.026 552.694 427.788 541.864 441.643 520.779C455.498 499.695 457.199 476.34 445.443 468.614C433.686 460.889 412.924 471.719 399.07 492.804C385.215 513.889 383.514 537.244 395.27 544.969Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.6849 168.924C-43.7794 193.165 -6.34454 197.031 8.92813 177.559C24.2008 158.088 11.5279 122.652 -19.3777 98.4109C-50.2832 74.17 -87.718 70.3037 -102.991 89.7753C-118.263 109.247 -105.59 144.683 -74.6849 168.924Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.716 91.16C15.3134 115.927 49.4079 122.709 64.4362 106.308C79.4645 89.9069 69.7357 56.5336 42.7063 31.7665C15.6769 6.99943 -18.4176 0.217468 -33.4459 16.6185C-48.4742 33.0196 -38.7454 66.3929 -11.716 91.16Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1039 199.042C74.7119 229.844 100.083 248.611 118.771 240.962C137.46 233.312 142.389 202.141 129.781 171.34C117.173 140.538 91.8025 121.771 73.1139 129.42C54.4252 137.07 49.496 168.241 62.1039 199.042Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.45948 254.791C11.3177 282.544 36.6857 298.132 55.2016 289.607C73.7175 281.083 78.3697 251.674 65.5925 223.921C52.8154 196.168 27.4474 180.581 8.93145 189.106C-9.58445 197.63 -14.2366 227.039 -1.45948 254.791Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3518 351.931C38.9298 378.569 59.1433 396.489 77.5001 391.956C95.8568 387.423 105.405 362.154 98.8273 335.516C92.2493 308.877 72.0357 290.957 53.679 295.49C35.3223 300.023 25.7738 325.293 32.3518 351.931Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5314 308.438C104.423 333.695 121.811 351.228 137.368 347.599C152.925 343.969 160.761 320.553 154.869 295.296C148.977 270.039 131.589 252.507 116.032 256.136C100.475 259.765 92.6396 283.182 98.5314 308.438Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.436 380.122C325.16 387.399 331.403 390.645 334.375 387.357C337.347 384.069 335.921 375.505 331.197 368.228C326.473 360.951 320.229 357.705 317.257 360.993C314.286 364.281 315.712 372.845 320.436 380.122Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4922 455.976C72.1292 477.784 92.9361 489.52 107.966 482.189C122.995 474.859 126.556 451.237 115.919 429.429C105.282 407.621 84.4753 395.884 69.4457 403.215C54.4161 410.546 50.8552 434.167 61.4922 455.976Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4922 455.976C72.1292 477.784 92.9361 489.52 107.966 482.189C122.995 474.859 126.556 451.237 115.919 429.429C105.282 407.621 84.4753 395.884 69.4457 403.215C54.4161 410.546 50.8552 434.167 61.4922 455.976Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.821 415.44C332.083 425.78 337.108 432.552 342.044 430.572C346.973 428.589 349.949 418.605 348.687 408.265C347.425 397.926 342.399 391.154 337.468 393.126C332.539 395.109 329.562 405.094 330.825 415.433L330.821 415.44Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.489 448.883C313.288 457.904 313.226 466.34 318.355 467.721C323.484 469.103 331.863 462.906 337.071 453.889C342.272 444.867 342.334 436.432 337.205 435.05C332.076 433.669 323.697 439.866 318.489 448.883Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.125 471.842C266.611 477.529 258.654 487.331 263.361 493.742C268.069 500.154 283.651 500.741 298.168 495.064C312.683 489.377 320.639 479.575 315.932 473.164C311.225 466.753 295.643 466.165 281.125 471.842Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.175 487.672C192.454 476.42 183.922 459.692 190.128 450.318C196.327 440.939 214.918 442.465 231.634 453.725C248.355 464.977 256.887 481.705 250.688 491.083C244.489 500.461 225.898 498.936 209.182 487.676L209.175 487.672Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.692 395.823C164.993 374.018 177.534 357.748 189.712 359.485C201.885 361.23 209.08 380.32 205.781 402.136C202.48 423.941 189.939 440.211 177.761 438.474C165.588 436.73 158.393 417.639 161.692 395.823Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.508 587.822C294.58 598.916 318.242 597.654 341.359 585.003C364.476 572.351 378.294 553.101 372.222 542.007C366.15 530.913 342.488 532.175 319.371 544.826C296.254 557.478 282.436 576.728 288.508 587.822Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.659 612.936C210.203 609.28 192.11 594.038 194.255 578.873C196.395 563.715 217.957 554.388 242.417 558.036C266.873 561.692 284.965 576.935 282.821 592.1C280.68 607.257 259.119 616.585 234.659 612.936Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.379 543.242C110.16 523.011 108.725 499.399 121.178 490.49C133.631 481.582 155.258 490.771 169.481 510.994C183.699 531.225 185.134 554.838 172.681 563.746C160.229 572.654 138.602 563.466 124.379 543.242Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.695 329.557C424.969 347.171 428.932 366.671 420.53 373.115C412.129 379.56 394.56 370.5 381.275 352.889C368.001 335.274 364.038 315.775 372.44 309.33C380.841 302.886 398.41 311.946 411.695 329.557Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63 267.185C343.687 267.537 361.502 276.398 361.418 286.977C361.341 297.56 343.393 305.864 321.337 305.511C299.28 305.159 281.465 296.298 281.549 285.72C281.626 275.136 299.574 266.833 321.63 267.185Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.161 298.621C230.724 282.989 250.463 277.303 259.25 285.905C268.033 294.515 262.539 314.162 246.976 329.794C231.413 345.426 211.673 351.113 202.887 342.51C194.104 333.9 199.598 314.253 215.161 298.621Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.261 455.339C429.833 457.033 417.439 440.324 414.579 418.023C411.715 395.711 419.469 376.257 431.89 374.56",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.261 455.339C429.833 457.033 417.439 440.324 414.579 418.023C411.715 395.711 419.469 376.257 431.89 374.56",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.405 545.059C383.558 537.472 385.125 514.188 398.908 493.057C412.682 471.923 433.454 460.941 445.301 468.529",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.405 545.059C383.558 537.472 385.125 514.188 398.908 493.057C412.682 471.923 433.454 460.941 445.301 468.529",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.716 91.1599C15.3134 115.927 49.4079 122.709 64.4362 106.308C79.4645 89.9068 69.7357 56.5334 42.7063 31.7664C15.6769 6.99931 -18.4176 0.217346 -33.4459 16.6184C-48.4742 33.0195 -38.7454 66.3928 -11.716 91.1599Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.789 240.976C100.1 248.625 74.723 229.864 62.1155 199.06C49.5039 168.263 54.4372 137.09 73.1267 129.441",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.789 240.976C100.1 248.625 74.723 229.864 62.1155 199.06C49.5039 168.263 54.4372 137.09 73.1267 129.441",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.23899 255.274C-14.1929 227.607 -9.78467 198.046 8.61835 189.255L-1.23899 255.274Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.23899 255.274C-14.1929 227.607 -9.78467 198.046 8.61835 189.255",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3518 351.931C38.9298 378.569 59.1433 396.489 77.5001 391.956C95.8568 387.423 105.405 362.154 98.8273 335.516C92.2493 308.877 72.0357 290.957 53.679 295.49C35.3223 300.023 25.7738 325.293 32.3518 351.931Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.081 256.134C131.65 252.556 149.026 270.132 154.885 295.388L116.081 256.134Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.081 256.134C131.65 252.556 149.026 270.132 154.885 295.388",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.364 387.36C337.335 384.072 335.909 375.508 331.185 368.231C326.461 360.954 320.218 357.708 317.246 360.996",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.364 387.36C337.335 384.072 335.909 375.508 331.185 368.231C326.461 360.954 320.218 357.708 317.246 360.996",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.209 482.035C93.2929 489.597 72.4452 478.1 61.6546 456.367L108.209 482.035Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.209 482.035C93.2929 489.597 72.4452 478.1 61.6546 456.367",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.044 430.572C346.973 428.589 349.949 418.605 348.687 408.265L342.044 430.572Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.044 430.572C346.973 428.589 349.949 418.605 348.687 408.265",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.362 467.725C323.491 469.107 331.87 462.91 337.078 453.893L318.362 467.725Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.362 467.725C323.491 469.107 331.87 462.91 337.078 453.893",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.361 493.742C268.069 500.154 283.651 500.741 298.168 495.064L263.361 493.742Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.361 493.742C268.069 500.154 283.651 500.741 298.168 495.064",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.175 487.672C192.454 476.42 183.922 459.692 190.128 450.318L209.175 487.672Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.175 487.672C192.454 476.42 183.922 459.692 190.128 450.318",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.692 395.823C164.993 374.018 177.534 357.748 189.712 359.485C201.885 361.23 209.08 380.32 205.781 402.136C202.48 423.941 189.939 440.211 177.761 438.474C165.588 436.73 158.393 417.639 161.692 395.823Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.561 584.879C318.475 597.591 294.742 598.949 288.553 587.918L341.561 584.879Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.561 584.879C318.475 597.591 294.742 598.949 288.553 587.918",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.659 612.936C210.203 609.28 192.11 594.038 194.255 578.873L234.659 612.936Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.659 612.936C210.203 609.28 192.11 594.038 194.255 578.873",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.681 563.746C160.228 572.654 138.602 563.466 124.379 543.242C110.16 523.011 108.725 499.399 121.178 490.49",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.681 563.746C160.228 572.654 138.602 563.466 124.379 543.242C110.16 523.011 108.725 499.399 121.178 490.49",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.275 352.889C368.001 335.274 364.038 315.775 372.44 309.33C380.841 302.886 398.41 311.946 411.696 329.557",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.275 352.889C368.001 335.274 364.038 315.775 372.44 309.33C380.841 302.886 398.41 311.946 411.696 329.557",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63 267.185C343.687 267.537 361.502 276.398 361.418 286.977C361.341 297.56 343.393 305.864 321.336 305.511C299.28 305.159 281.465 296.298 281.549 285.72C281.626 275.136 299.574 266.833 321.63 267.185Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.887 342.51C194.104 333.9 199.598 314.253 215.161 298.621L202.887 342.51Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.887 342.51C194.104 333.9 199.598 314.253 215.161 298.621",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.572 411.876C462.436 434.188 454.682 453.641 442.261 455.339C429.833 457.033 417.439 440.324 414.579 418.023C411.715 395.711 419.469 376.257 431.89 374.56C444.318 372.866 456.712 389.575 459.572 411.876Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.27 544.969C407.026 552.694 427.788 541.864 441.643 520.779C455.498 499.695 457.199 476.34 445.443 468.614C433.686 460.889 412.924 471.719 399.07 492.804C385.215 513.889 383.514 537.244 395.27 544.969Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.162 -63.1821C-134.322 -67.2967 -146.321 -68.5781 -157.254 -67.6665L-239.711 80.0012C-232.339 91.1539 -224.78 101.766 -221.618 103.532C-221.618 103.532 -204.899 99.9798 -186.658 110.165C-168.418 120.35 -92.7785 166.274 -76.2638 182.859C-59.7492 199.444 0.66626 279.216 16.2994 328.457C31.9327 377.699 44.6771 459.312 59.4887 501.993C66.8661 523.254 114.291 583.01 137.863 591.524C161.435 600.037 195.1 623.485 218.469 636.534C241.838 649.583 274.399 636.465 297.671 646.948C320.943 657.431 389.59 588.464 394.184 583.667C398.786 578.873 458.911 520.375 470.321 515.696C481.73 511.018 494.404 404.655 479.898 373.734C465.393 342.813 379.859 249.746 365.111 241.511C350.363 233.276 286.794 217.808 247.171 243.779C207.548 269.749 172.452 274.926 152.154 336.184C135.255 387.182 134.819 400.356 136.378 424.211C127.676 383.104 120.808 328.921 116.504 257.237C105.94 81.1397 -16.1418 -30.3146 -121.162 -63.1821ZM195.728 378.1C217.67 300.282 279.081 281.849 341.701 300.241C404.313 318.63 427.866 373.371 438.005 412.181C448.144 450.992 424.465 508.599 376.586 546.303C328.704 584.014 248.924 579.081 196.105 544.207C177.151 531.698 159.337 507.872 144.992 458.772C167.597 490.529 235.48 523.594 274.193 531.38C320.569 540.702 332.003 510.262 372.929 448.415C413.855 386.569 297.046 331.362 297.046 331.362C297.403 327.74 290.223 336.513 301.973 347.617C326.573 370.873 330.12 387.031 335.785 406.567C341.129 424.989 323.054 473.165 257.696 474.534C199.143 475.766 187.628 406.86 195.739 378.097L195.728 378.1Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0844 562.458C58.3483 518.238 21.1936 315.694 -28.329 256.076C-69.4068 206.621 -186.451 132.822 -245.33 119.762C-234.446 139.036 -219.212 155.743 -204.391 162.604C-142.385 191.318 -72.8848 232.948 -30.6643 304.591C15.659 383.193 19.1192 431.585 47.2978 495.108C68.5382 542.995 133.482 626.413 223.94 649.368C184.291 631.415 132.055 602.39 97.0844 562.458Z",
    fill: "#D16984",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.162 -63.1821C-134.322 -67.2967 -146.321 -68.5781 -157.254 -67.6665L-239.711 80.0012C-232.339 91.1539 -224.78 101.766 -221.618 103.532C-221.618 103.532 -204.899 99.9798 -186.658 110.165C-168.418 120.35 -92.7785 166.274 -76.2638 182.859C-59.7492 199.444 0.66626 279.216 16.2994 328.457C31.9327 377.699 44.6771 459.312 59.4887 501.993C66.8661 523.254 114.291 583.01 137.863 591.524C161.435 600.037 195.1 623.485 218.469 636.534C241.838 649.583 274.399 636.465 297.671 646.948C320.943 657.431 389.59 588.464 394.184 583.667C398.786 578.873 458.911 520.375 470.321 515.696C481.73 511.018 494.404 404.655 479.898 373.734C465.393 342.813 379.859 249.746 365.111 241.511C350.363 233.276 286.794 217.808 247.171 243.779C207.548 269.749 172.452 274.926 152.154 336.184C135.255 387.182 134.819 400.356 136.378 424.211C127.676 383.104 120.808 328.921 116.504 257.237C105.94 81.1397 -16.1418 -30.3146 -121.162 -63.1821ZM195.728 378.1C217.67 300.282 279.081 281.849 341.701 300.241C404.313 318.63 427.866 373.371 438.005 412.181C448.144 450.992 424.465 508.599 376.586 546.303C328.704 584.014 248.924 579.081 196.105 544.207C177.151 531.698 159.337 507.872 144.992 458.772C167.597 490.529 235.48 523.594 274.193 531.38C320.569 540.702 332.003 510.262 372.929 448.415C413.855 386.569 297.046 331.362 297.046 331.362C297.403 327.74 290.223 336.513 301.973 347.617C326.573 370.873 330.12 387.031 335.785 406.567C341.129 424.989 323.054 473.165 257.696 474.534C199.143 475.766 187.628 406.86 195.739 378.097L195.728 378.1Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.622 254.774C56.0573 357.713 114.12 466.279 175.961 510.041C227.372 546.421 298.806 587.483 363.087 500.91C460.941 369.125 284.829 319.525 297.031 331.354C330.531 363.853 351.347 365.668 358.071 419.54C362.818 457.611 305.018 527.476 230.925 503.947C144.269 476.425 147.513 356.577 197.386 305.925C247.259 255.272 352.735 220.894 422.894 334.53C480.866 428.434 444.816 492.994 387.768 556.58C350.279 598.362 297.91 636.523 229.404 617.692C177.447 603.406 100.53 605.567 31.0889 340.393C13.5816 273.531 -57.3264 149.014 -157.312 113.664C-198.412 99.136 -221.814 84.1816 -235.467 72.3999L-253.035 103.862C-242.628 129.385 -223.191 153.906 -204.402 162.608C-142.397 191.322 -72.8963 232.951 -30.6757 304.594C15.6476 383.196 20.5963 430.957 47.2864 495.111C82.6177 580.04 203.538 699.556 343.075 664.024C555.855 609.832 547.604 371.78 454.045 275.349C368.948 187.636 271.101 201.355 197.63 254.779L197.622 254.774Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.622 254.774C56.0573 357.713 114.12 466.279 175.961 510.041C227.372 546.421 298.806 587.483 363.087 500.91C460.941 369.125 284.829 319.525 297.031 331.354C330.531 363.853 351.347 365.668 358.071 419.54C362.818 457.611 305.018 527.476 230.925 503.947C144.269 476.425 147.513 356.577 197.386 305.925C247.259 255.272 352.735 220.894 422.894 334.53C480.866 428.434 444.816 492.994 387.768 556.58C350.279 598.362 297.91 636.523 229.404 617.692C177.447 603.406 100.53 605.567 31.0889 340.393C13.5816 273.531 -57.3264 149.014 -157.312 113.664C-198.412 99.136 -221.814 84.1816 -235.467 72.3999L-253.035 103.862C-242.628 129.385 -223.191 153.906 -204.402 162.608C-142.397 191.322 -72.8963 232.951 -30.6757 304.594C15.6476 383.196 20.5963 430.957 47.2864 495.111C82.6177 580.04 203.538 699.556 343.075 664.024C555.855 609.832 547.604 371.78 454.045 275.349C368.948 187.636 271.101 201.355 197.63 254.779L197.622 254.774Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.622 254.774C56.0573 357.713 114.12 466.279 175.961 510.041C227.372 546.421 298.806 587.483 363.087 500.91C460.941 369.125 284.829 319.525 297.031 331.354C330.531 363.853 351.347 365.668 358.071 419.54C362.818 457.611 305.018 527.476 230.925 503.947C144.269 476.425 147.513 356.577 197.386 305.925C247.259 255.272 352.735 220.894 422.894 334.53C480.866 428.434 444.816 492.994 387.768 556.58C350.279 598.362 297.91 636.523 229.404 617.692C177.447 603.406 100.53 605.567 31.0889 340.393C13.5816 273.531 -57.3264 149.014 -157.312 113.664C-198.412 99.136 -221.814 84.1816 -235.467 72.3999L-253.035 103.862C-242.628 129.385 -223.191 153.906 -204.402 162.608C-142.397 191.322 -72.8963 232.951 -30.6757 304.594C15.6476 383.196 20.5963 430.957 47.2864 495.111C82.6177 580.04 203.538 699.556 343.075 664.024C555.855 609.832 547.604 371.78 454.045 275.349C368.948 187.636 271.101 201.355 197.63 254.779L197.622 254.774Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.6849 168.924C-43.7794 193.165 -6.34454 197.031 8.92813 177.56C24.2008 158.088 11.5279 122.652 -19.3777 98.411C-50.2832 74.1701 -87.718 70.3038 -102.991 89.7754C-118.263 109.247 -105.59 144.683 -74.6849 168.924Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.7161 91.1599C15.3134 115.927 49.4079 122.709 64.4362 106.308C79.4645 89.9068 69.7357 56.5334 42.7063 31.7664C15.6769 6.99931 -18.4177 0.217346 -33.446 16.6184C-48.4743 33.0195 -38.7455 66.3928 -11.7161 91.1599Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53 78.4853C16.2372 91.9616 34.7888 95.6517 42.9661 86.7274C51.1434 77.8032 45.8498 59.644 31.1426 46.1677C16.4354 32.6915 -2.11617 29.0014 -10.2935 37.9256C-18.4708 46.8499 -13.1772 65.0091 1.53 78.4853Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1039 199.042C74.7119 229.844 100.083 248.611 118.771 240.962C137.46 233.312 142.389 202.141 129.781 171.34C117.173 140.538 91.8025 121.771 73.1139 129.42C54.4252 137.07 49.496 168.241 62.1039 199.042Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8804 193.762C84.7391 210.518 98.5445 220.726 108.716 216.563C118.887 212.399 121.572 195.441 114.713 178.685C107.855 161.93 94.0492 151.721 83.8781 155.885C73.7069 160.048 71.0216 177.007 77.8804 193.762Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.45948 254.791C11.3177 282.544 36.6857 298.132 55.2016 289.607C73.7175 281.083 78.3697 251.674 65.5925 223.921C52.8154 196.168 27.4474 180.581 8.93145 189.106C-9.58445 197.63 -14.2366 227.039 -1.45948 254.791Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.193 248.685C21.1455 263.786 34.9496 272.267 45.0254 267.628C55.1012 262.99 57.6333 246.987 50.6809 231.886C43.7285 216.785 29.9243 208.304 19.8485 212.943C9.77267 217.581 7.24063 233.584 14.193 248.685Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3518 351.931C38.9298 378.569 59.1433 396.489 77.5001 391.956C95.8568 387.423 105.405 362.154 98.8273 335.516C92.2493 308.877 72.0357 290.957 53.679 295.49C35.3223 300.023 25.7738 325.293 32.3518 351.931Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6749 349.084C51.2543 363.579 62.2503 373.331 72.2352 370.865C82.2201 368.4 87.4128 354.65 83.8334 340.155C80.254 325.66 69.2579 315.908 59.273 318.373C49.2881 320.839 44.0955 334.589 47.6749 349.084Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5314 308.438C104.423 333.695 121.811 351.228 137.368 347.599C152.925 343.969 160.761 320.553 154.869 295.296C148.977 270.039 131.589 252.507 116.032 256.136C100.475 259.765 92.6396 283.182 98.5314 308.438Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.604 309.036C106.876 296.145 108.677 282.838 116.624 279.326C124.572 275.814 135.662 283.412 141.398 296.307C147.126 309.198 145.326 322.505 137.378 326.017C129.43 329.529 118.34 321.931 112.604 309.036Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.436 380.122C325.16 387.399 331.403 390.645 334.375 387.357C337.347 384.069 335.921 375.505 331.197 368.228C326.473 360.951 320.229 357.705 317.257 360.993C314.286 364.281 315.712 372.845 320.436 380.122Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.429 376.152C322.647 380.625 325.386 383.357 326.554 382.248C327.722 381.139 326.871 376.612 324.653 372.139C322.434 367.666 319.696 364.934 318.528 366.043C317.36 367.153 318.21 371.68 320.429 376.152Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4922 455.976C72.1292 477.784 92.9361 489.52 107.966 482.189C122.995 474.859 126.556 451.237 115.919 429.429C105.282 407.621 84.4753 395.884 69.4457 403.215C54.4161 410.546 50.8552 434.167 61.4922 455.976Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2829 450.867C68.4122 439.042 70.2286 426.12 78.3467 422.01C86.4649 417.9 97.8043 424.154 103.675 435.98C109.546 447.805 107.729 460.728 99.6112 464.838C91.493 468.948 80.1537 462.693 74.2829 450.867Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4922 455.976C72.1292 477.784 92.9361 489.52 107.966 482.189C122.995 474.859 126.556 451.237 115.919 429.429C105.282 407.621 84.4753 395.884 69.4457 403.215C54.4161 410.546 50.8552 434.167 61.4922 455.976Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2829 450.867C68.4122 439.042 70.2286 426.12 78.3467 422.01C86.4649 417.9 97.8043 424.154 103.675 435.98C109.546 447.805 107.729 460.728 99.6112 464.838C91.493 468.948 80.1537 462.693 74.2829 450.867Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.821 415.44C332.083 425.78 337.108 432.552 342.044 430.572C346.973 428.589 349.949 418.605 348.687 408.265C347.425 397.926 342.399 391.154 337.468 393.126C332.539 395.109 329.562 405.094 330.825 415.433L330.821 415.44Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.916 411.153C332.951 417.14 334.474 421.533 336.314 420.943C338.15 420.361 339.616 415.029 339.581 409.042C339.546 403.055 338.024 398.663 336.183 399.252C334.347 399.834 332.881 405.166 332.916 411.153Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.489 448.883C313.288 457.904 313.226 466.34 318.355 467.721C323.484 469.103 331.863 462.906 337.071 453.889C342.272 444.867 342.334 436.432 337.205 435.05C332.076 433.669 323.697 439.866 318.489 448.883Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3 448.691C317.305 453.882 316.409 458.434 318.285 458.866C320.166 459.29 324.123 455.427 327.118 450.236C330.112 445.046 331.009 440.493 329.128 440.069C327.248 439.644 323.29 443.508 320.296 448.698L320.3 448.691Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.125 471.842C266.611 477.529 258.654 487.331 263.361 493.742C268.069 500.154 283.651 500.741 298.168 495.064C312.683 489.377 320.639 479.575 315.932 473.164C311.225 466.753 295.643 466.165 281.125 471.842Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41 473.3C275.059 476.568 269.746 481.051 271.554 483.312C273.354 485.568 281.589 484.748 289.94 481.48C298.291 478.212 303.604 473.729 301.796 471.469C299.996 469.212 291.765 470.025 283.41 473.3Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.175 487.672C192.454 476.42 183.922 459.692 190.128 450.318C196.327 440.939 214.918 442.465 231.634 453.725C248.355 464.977 256.887 481.705 250.688 491.083C244.489 500.461 225.898 498.936 209.182 487.676L209.175 487.672Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2 476.668C212.097 470.545 207.46 461.44 210.834 456.345C214.212 451.244 224.317 452.074 233.42 458.197C242.523 464.319 247.16 473.425 243.786 478.519C240.408 483.62 230.303 482.79 221.2 476.668Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.692 395.823C164.993 374.018 177.534 357.748 189.712 359.485C201.885 361.23 209.08 380.32 205.781 402.136C202.48 423.941 189.939 440.211 177.761 438.474C165.588 436.73 158.393 417.639 161.692 395.823Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.513 398.719C177.308 386.852 184.137 378 190.757 378.953C197.38 379.898 201.3 390.288 199.498 402.15C197.703 414.017 190.873 422.869 184.254 421.916C177.631 420.971 173.711 410.581 175.513 398.719Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.508 587.822C294.58 598.916 318.242 597.654 341.359 585.003C364.476 572.351 378.294 553.101 372.222 542.007C366.15 530.913 342.488 532.175 319.371 544.826C296.254 557.478 282.436 576.728 288.508 587.822Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.208 570.484C320.646 577.397 307.731 578.136 304.371 572.14C301.003 566.14 308.456 555.671 321.017 548.758C333.578 541.845 346.486 541.103 349.854 547.103C353.222 553.103 345.769 563.571 333.208 570.484Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.659 612.936C210.203 609.28 192.11 594.038 194.255 578.873C196.395 563.715 217.957 554.388 242.417 558.036C266.873 561.692 284.965 576.935 282.821 592.1C280.68 607.257 259.119 616.585 234.659 612.936Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.249 592.957C223.939 590.972 214.096 582.675 215.266 574.426C216.437 566.176 228.161 561.106 241.471 563.091C254.781 565.075 264.624 573.372 263.454 581.622C262.283 589.871 250.559 594.942 237.249 592.957Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.379 543.242C110.16 523.011 108.725 499.399 121.178 490.49C133.631 481.582 155.258 490.771 169.481 510.994C183.699 531.225 185.134 554.838 172.681 563.746C160.229 572.654 138.602 563.466 124.379 543.242Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.641 531.34C132.908 520.333 132.121 507.487 138.9 502.638C145.675 497.797 157.44 502.789 165.18 513.8C172.913 524.808 173.7 537.653 166.921 542.502C160.146 547.343 148.381 542.351 140.641 531.34Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.695 329.557C424.969 347.171 428.932 366.671 420.53 373.115C412.129 379.56 394.56 370.5 381.275 352.889C368.001 335.274 364.038 315.775 372.44 309.33C380.841 302.886 398.41 311.946 411.695 329.557Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.45 341.728C405.676 351.317 407.829 361.923 403.256 365.423C398.691 368.928 389.123 363.999 381.901 354.422C374.675 344.834 372.522 334.228 377.095 330.727C381.66 327.223 391.228 332.151 398.45 341.728Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63 267.185C343.687 267.537 361.502 276.398 361.418 286.977C361.341 297.56 343.393 305.864 321.337 305.511C299.28 305.159 281.465 296.298 281.549 285.72C281.626 275.136 299.574 266.833 321.63 267.185Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.088 285.122C335.087 285.316 344.777 290.13 344.736 295.892C344.695 301.653 334.929 306.162 322.926 305.975C310.926 305.781 301.229 300.963 301.277 295.205C301.318 289.444 311.084 284.935 323.088 285.122Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.161 298.621C230.724 282.989 250.463 277.303 259.25 285.905C268.033 294.515 262.539 314.162 246.976 329.794C231.413 345.426 211.673 351.113 202.887 342.51C194.104 333.9 199.598 314.253 215.161 298.621Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.594 309.134C233.06 300.627 243.806 297.532 248.581 302.22C253.36 306.9 250.369 317.598 241.9 326.094C233.435 334.601 222.695 337.7 217.914 333.008C213.135 328.328 216.125 317.63 224.594 309.134Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.539 519.593C201.688 543.051 250.598 558.899 293.116 550.773C247.664 537.125 170.632 507.037 151.911 455.965C127.871 390.374 150.446 316.576 208.722 247.151C205.004 249.57 201.3 252.102 197.63 254.779C56.0647 357.717 106.698 475.83 168.546 519.597L168.539 519.593Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0844 562.458C58.3483 518.238 21.1936 315.694 -28.329 256.076C-69.4068 206.621 -186.451 132.822 -245.33 119.762C-234.446 139.036 -219.212 155.743 -204.391 162.604C-142.385 191.318 -72.8848 232.948 -30.6643 304.591C15.659 383.193 19.1192 431.585 47.2978 495.108C68.5382 542.995 133.482 626.413 223.94 649.368C184.291 631.415 132.055 602.39 97.0844 562.458Z",
    fill: "#D16984"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleProducts2);
export default __webpack_public_path__ + "static/media/tentacle_products2.aa1cc27042a7b8033b706117e0d2f101.svg";
export { ForwardRef as ReactComponent };